import React from "react";
import AppRoutes from "./Routes";
import InstallButton from "./components/pwaInstaller/installerButton";

const App = () => {
  console.log("Renderizou App!");
  return <>
    <AppRoutes />
    <InstallButton />
  </>;
};

export default App;
